const T = {
  'zh-HK':{
    aiLang:'Traditional Chinese',
    app:'EC TRAVEL', tagline:'探索 • 體驗 • 賺取',
    home:'當地', search:'搜尋', trips:'行程', booking:'預訂', profile:'我的',
    login:'登入', register:'註冊', logout:'登出',
    region:'洲份', country:'國家', city:'城市',
    searchBtn:'搜尋', searching:'搜尋中…',
    localTime:'當地時間', weather:'天氣預報',
    currency:'貨幣資訊', voltage:'電壓插頭', transport:'當地交通', tips:'旅遊需知',
    emergency:'緊急電話', taboos:'禁忌須知', tap_water:'龍頭水', tipping:'小費文化',
    spots:'熱門景點', all:'全部', culture:'文化', play:'玩樂', sight:'景點',
    districtFilterHome:'熱門景點的地區篩選', districtFilter:'地區篩選',
    nature:'大自然', shopping:'購物', food:'美食', topFood:'當地美食TOP10',
    deals:'當地優惠', loading:'載入中…', translating:'正在翻譯文章…',
    planTrip:'規劃行程', days:'旅行天數', style:'旅行風格', travelMode:'交通方式',
    genItinerary:'🗺️ 一鍵計劃', downloadPDF:'下載 PDF',
    menuAbout:'關於 EC Travel', menuAboutSub:'品牌故事與我們的使命',
    menuIntel:'旅遊情報', menuIntelSub:'目的地情報 · 簽證 · 安全',
    menuDeals:'旅遊優惠', menuDealsSub:'早鳥優惠及會員折扣',
    menuEvents:'旅遊活動', menuEventsSub:'本週精選活動 · 演唱會 · 展覽',
    menuContact:'聯絡我們', menuContactSub:'客服 · 合作 · 辦公室',
    menuFeedback:'意見反映', menuFeedbackSub:'評分 · 建議 · 問題反映',
    publicTransport:'公共交通', selfDrive:'自駕遊', bicycle:'自行車',
    localTransport:'本地交通', crossBorder:'跨境交通', tickets:'門票',
    dining:'飲食', accommodation:'住宿',
    departure:'出發地', destination:'目的地', depDate:'出發日期', returnDate:'回程日期',
    autoDaysHint:'根據出發及回程日期自動計算', autoDaysNeedDate:'填好出發及回程日期會自動計算天數',
    searchResults:'搜尋結果', noResults:'未找到結果，請重試',
    estCost:'預計費用', dayLabel:'第', dayUnit:'天',
    hotel:'住宿推薦', restaurant:'餐廳',
    hotelAiNote:'AI 建議，實際房型及價格請以下方地圖顯示為準',
    morning:'☀️ 早上', lunch:'🍱 午餐', afternoon:'🌤 下午', evening:'🌙 晚上',
    redo:'重新規劃', share:'分享',
    myAcc:'我的帳戶', saved:'已收藏', security:'安全設定',
    yourEarnings:'推廣收益', thisMonth:'本月', thisWeek:'本週',
    forgotPw:'忘記密碼？', sendReset:'發送重設連結',
    resetSent:'電郵已發送', resetSentDesc:'請查看收件箱重設密碼。',
    orWith:'或使用', noAcc:'還沒有帳戶？', hasAcc:'已有帳戶？',
    emailRequired:'電郵為必填', emailInvalid:'電郵格式不正確',
    pwRequired:'密碼為必填', pwPolicy:'密碼最少8位，包含大小寫及數字',
    pwNoMatch:'密碼不一致', phoneRequired:'電話為必填',
    deletedCooldown:'此電郵帳戶已被刪除，請於24小時後再重新註冊',
    confirmPw:'確認密碼', birthday:'出生日期（選填）', phone:'(區號)電話',
    selected:'已選', of:'，共',
    regions:{Asia:'亞洲',Europe:'歐洲',Americas:'北美洲','South America':'南美洲',Africa:'非洲','Middle East':'中東',Oceania:'大洋洲'},
    styleLabels:{culture:'文化體驗',shopping:'購物',entertainment:'娛樂',nature:'大自然',food:'美食體驗'},
    stylePresets:[
      {label:'🏛 文化深度',style:{culture:50,food:20,nature:15,entertainment:10,shopping:5}},
      {label:'🛍 購物之旅',style:{shopping:50,food:20,entertainment:15,culture:10,nature:5}},
      {label:'🌿 大自然探索',style:{nature:50,culture:20,food:20,entertainment:5,shopping:5}},
      {label:'👨‍👩‍👧 家庭娛樂',style:{entertainment:40,food:25,nature:20,culture:10,shopping:5}},
    ],
    dayOpts:Array.from({length:12},(_,i)=>`${i+1}天`),
    from:'由', priceFrom:'起',
    bookLinks:'預訂連結', recommended:'推薦',
    addDest:'增加目的地', multiDestHint:'可增加多個目的地', maxDaysHint:'會員最多{n}天',
    activities:['主題樂園','海洋館','動物園','博物館','寵物Café','溫泉・SPA','室內遊樂場','當地文化體驗','音樂 Live Bar','Outlet'],
    daysSuffix:'天',
    freeUsed:'今日免費次數已用盡，下次生成需觀看10秒贊助廣告解鎖',
    freeLeft:'今日尚有 {n} 次免費生成',
    tripSaved:'✅ 行程已儲存！可在「我的 → 儲存行程」查看',
    maxTrips:'最多只能儲存 {n} 個行程，請先刪除舊行程',
    perNight:'晚', copied:'行程已複製到剪貼板！', retryTxt:'請重試', saveTrip:'儲存行程',
    resetStyle:'平均分配', styleDone:'完成', styleTotalLbl:'總計',
    styleOver:'超出100%，請減少', styleNeed:'還需 {n}%',
    termsTitle:'使用條款', privacyTitle:'私隱政策', adsTitle:'廣告查詢',
  },
  'zh-CN':{
    aiLang:'Simplified Chinese',
    app:'EC TRAVEL', tagline:'探索 • 体验 • 赚取',
    home:'当地', search:'搜索', trips:'行程', booking:'预订', profile:'我的',
    login:'登录', register:'注册', logout:'退出',
    region:'洲份', country:'国家', city:'城市',
    searchBtn:'搜索', searching:'搜索中…',
    localTime:'当地时间', weather:'天气预报',
    currency:'货币信息', voltage:'电压插头', transport:'当地交通', tips:'旅游须知',
    emergency:'紧急电话', taboos:'禁忌须知', tap_water:'自来水', tipping:'小费文化',
    spots:'热门景点', all:'全部', culture:'文化', play:'玩乐', sight:'景点',
    districtFilterHome:'热门景点的地区筛选', districtFilter:'地区筛选',
    nature:'大自然', shopping:'购物', food:'美食', topFood:'当地美食TOP10',
    deals:'当地优惠', loading:'加载中…', translating:'正在翻译文章…',
    planTrip:'规划行程', days:'旅行天数', style:'旅行风格', travelMode:'交通方式',
    genItinerary:'🗺️ 一键计划', downloadPDF:'下载 PDF',
    menuAbout:'关于 EC Travel', menuAboutSub:'品牌故事与我们的使命',
    menuIntel:'旅游情报', menuIntelSub:'目的地情报 · 签证 · 安全',
    menuDeals:'旅游优惠', menuDealsSub:'早鸟优惠及会员折扣',
    menuEvents:'旅游活动', menuEventsSub:'本周精选活动 · 演唱会 · 展览',
    menuContact:'联系我们', menuContactSub:'客服 · 合作 · 办公室',
    menuFeedback:'意见反映', menuFeedbackSub:'评分 · 建议 · 问题反映',
    publicTransport:'公共交通', selfDrive:'自驾游', bicycle:'自行车',
    localTransport:'本地交通', crossBorder:'跨境交通', tickets:'门票',
    dining:'饮食', accommodation:'住宿',
    departure:'出发地', destination:'目的地', depDate:'出发日期', returnDate:'回程日期',
    autoDaysHint:'根据出发及回程日期自动计算', autoDaysNeedDate:'填好出发及回程日期会自动计算天数',
    searchResults:'搜索结果', noResults:'未找到结果，请重试',
    estCost:'预计费用', dayLabel:'第', dayUnit:'天',
    hotel:'住宿推荐', restaurant:'餐厅',
    hotelAiNote:'AI 建议，实际房型及价格请以下方地图显示为准',
    morning:'☀️ 早上', lunch:'🍱 午餐', afternoon:'🌤 下午', evening:'🌙 晚上',
    redo:'重新规划', share:'分享',
    myAcc:'我的账户', saved:'已收藏', security:'安全设置',
    yourEarnings:'推广收益', thisMonth:'本月', thisWeek:'本周',
    forgotPw:'忘记密码？', sendReset:'发送重设链接',
    resetSent:'邮件已发送', resetSentDesc:'请查看收件箱重设密码。',
    orWith:'或使用', noAcc:'还没有账户？', hasAcc:'已有账户？',
    emailRequired:'邮箱为必填', emailInvalid:'邮箱格式不正确',
    pwRequired:'密码为必填', pwPolicy:'密码最少8位，包含大小写及数字',
    pwNoMatch:'密码不一致', phoneRequired:'电话为必填',
    deletedCooldown:'此邮箱账户已被删除，请于24小时后再重新注册',
    confirmPw:'确认密码', birthday:'出生日期（选填）', phone:'(区号)电话',
    selected:'已选', of:'，共',
    regions:{Asia:'亚洲',Europe:'欧洲',Americas:'北美洲','South America':'南美洲',Africa:'非洲','Middle East':'中东',Oceania:'大洋洲'},
    styleLabels:{culture:'文化体验',shopping:'购物',entertainment:'娱乐',nature:'大自然',food:'美食体验'},
    stylePresets:[
      {label:'🏛 文化深度',style:{culture:50,food:20,nature:15,entertainment:10,shopping:5}},
      {label:'🛍 购物之旅',style:{shopping:50,food:20,entertainment:15,culture:10,nature:5}},
      {label:'🌿 大自然探索',style:{nature:50,culture:20,food:20,entertainment:5,shopping:5}},
      {label:'👨‍👩‍👧 家庭娱乐',style:{entertainment:40,food:25,nature:20,culture:10,shopping:5}},
    ],
    dayOpts:Array.from({length:12},(_,i)=>`${i+1}天`),
    from:'由', priceFrom:'起',
    bookLinks:'预订链接', recommended:'推荐',
    addDest:'增加目的地', multiDestHint:'可增加多个目的地', maxDaysHint:'会员最多{n}天',
    activities:['主题乐园','海洋馆','动物园','博物馆','宠物Café','温泉・SPA','室内游乐场','当地文化体验','音乐 Live Bar','Outlet'],
    daysSuffix:'天',
    freeUsed:'今日免费次数已用尽，下次生成需观看10秒赞助广告解锁',
    freeLeft:'今日尚有 {n} 次免费生成',
    tripSaved:'✅ 行程已保存！可在「我的 → 保存行程」查看',
    maxTrips:'最多只能保存 {n} 个行程，请先删除旧行程',
    perNight:'晚', copied:'行程已复制到剪贴板！', retryTxt:'请重试', saveTrip:'保存行程',
    resetStyle:'平均分配', styleDone:'完成', styleTotalLbl:'总计',
    styleOver:'超出100%，请减少', styleNeed:'还需 {n}%',
    termsTitle:'使用条款', privacyTitle:'隐私政策', adsTitle:'广告咨询',
  },
  'en':{
    aiLang:'English',
    app:'EC TRAVEL', tagline:'Explore • Experience • Earn',
    home:'Local', search:'Search', trips:'Trips', booking:'Book', profile:'Profile',
    login:'Login', register:'Register', logout:'Logout',
    region:'Region', country:'Country', city:'City',
    searchBtn:'Search', searching:'Searching…',
    localTime:'Local Time', weather:'7-Day Forecast',
    currency:'Currency', voltage:'Voltage', transport:'Transport', tips:'Travel Tips',
    emergency:'Emergency', taboos:'Taboos', tap_water:'Tap Water', tipping:'Tipping',
    spots:'Attractions', all:'All', culture:'Culture', play:'Fun', sight:'Sights',
    districtFilterHome:'Filter by Area', districtFilter:'Filter by Area',
    nature:'Nature', shopping:'Shopping', food:'Food', topFood:'Top 10 Local Food',
    deals:'Local Deals', loading:'Loading…', translating:'Translating article…',
    planTrip:'Plan Trip', days:'Duration', style:'Travel Style', travelMode:'Transport Mode',
    genItinerary:'🗺️ Plan My Trip', downloadPDF:'Download PDF',
    menuAbout:'About EC Travel', menuAboutSub:'Our story & mission',
    menuIntel:'Travel Intel', menuIntelSub:'Destination info · Visa · Safety',
    menuDeals:'Travel Deals', menuDealsSub:'Early bird & member discounts',
    menuEvents:'Events', menuEventsSub:"This week's picks · concerts · exhibitions",
    menuContact:'Contact Us', menuContactSub:'Support · Partners · Office',
    menuFeedback:'Feedback', menuFeedbackSub:'Rate · Suggest · Report',
    publicTransport:'Public Transport', selfDrive:'Self Drive', bicycle:'Bicycle',
    localTransport:'Local Transport', crossBorder:'International', tickets:'Tickets',
    dining:'Dining', accommodation:'Accommodation',
    departure:'Departure', destination:'Destination', depDate:'Departure Date', returnDate:'Return Date',
    autoDaysHint:'Calculated from your departure and return dates', autoDaysNeedDate:'Fill in both dates to auto-calculate the trip length',
    searchResults:'Search Results', noResults:'No results found, please try again',
    estCost:'Est. Cost', dayLabel:'Day ', dayUnit:'',
    hotel:'Accommodation', restaurant:'Restaurant',
    hotelAiNote:'AI suggestion — see the map below for actual room type and price',
    morning:'☀️ Morning', lunch:'🍱 Lunch', afternoon:'🌤 Afternoon', evening:'🌙 Evening',
    redo:'Start over', share:'Share',
    myAcc:'My Account', saved:'Saved', security:'Security',
    yourEarnings:'Referral Earnings', thisMonth:'This month', thisWeek:'This week',
    forgotPw:'Forgot password?', sendReset:'Send Reset Link',
    resetSent:'Email Sent', resetSentDesc:'Check your inbox to reset your password.',
    orWith:'or with', noAcc:"Don't have an account?", hasAcc:'Already have an account?',
    emailRequired:'Email is required', emailInvalid:'Invalid email format',
    pwRequired:'Password is required', pwPolicy:'Min 8 chars, include upper, lower & number',
    pwNoMatch:'Passwords do not match', phoneRequired:'Phone is required',
    deletedCooldown:'This email was recently deleted. Please try again after 24 hours.',
    confirmPw:'Confirm Password', birthday:'Date of Birth (optional)', phone:'(+code) Phone',
    selected:'selected', of:', total',
    regions:{Asia:'Asia',Europe:'Europe',Americas:'Americas','South America':'S. America',Africa:'Africa','Middle East':'Middle East',Oceania:'Oceania'},
    styleLabels:{culture:'Cultural',shopping:'Shopping',entertainment:'Entertainment',nature:'Nature',food:'Food & Dining'},
    stylePresets:[
      {label:'🏛 Culture Trip',style:{culture:50,food:20,nature:15,entertainment:10,shopping:5}},
      {label:'🛍 Shopping Tour',style:{shopping:50,food:20,entertainment:15,culture:10,nature:5}},
      {label:'🌿 Nature Escape',style:{nature:50,culture:20,food:20,entertainment:5,shopping:5}},
      {label:'👨‍👩‍👧 Family Fun',style:{entertainment:40,food:25,nature:20,culture:10,shopping:5}},
    ],
    dayOpts:Array.from({length:12},(_,i)=>`${i+1} Day${i?'s':''}`),
    from:'From', priceFrom:'',
    bookLinks:'Booking Links', recommended:'Recommended',
    addDest:'Add Destination', multiDestHint:'Add multiple destinations', maxDaysHint:'Max {n} days for members',
    activities:['Theme Park','Aquarium','Zoo','Museum','Pet Café','Hot Springs & Spa','Indoor Play','Local Culture','Live Music Bar','Outlet'],
    daysSuffix:' Days',
    freeUsed:'Daily free quota used. Watch a 10-sec sponsored ad to unlock next generation',
    freeLeft:'{n} free generation(s) remaining today',
    tripSaved:'✅ Trip saved! View it in Profile → Saved Trips',
    maxTrips:'Max {n} trips allowed. Please delete an old trip first',
    perNight:'night', copied:'Itinerary copied to clipboard!', retryTxt:'Please try again', saveTrip:'Save Trip',
    resetStyle:'Split Evenly', styleDone:'Done', styleTotalLbl:'Total',
    styleOver:'Exceeds 100%, please reduce', styleNeed:'Need {n}% more',
    termsTitle:'Terms of Service', privacyTitle:'Privacy Policy', adsTitle:'Ad Enquiry',
  },
  'ja':{
    aiLang:'Japanese',
    app:'EC TRAVEL', tagline:'探索 • 体験 • 収益',
    home:'現地', search:'検索', trips:'旅程', booking:'予約', profile:'マイページ',
    login:'ログイン', register:'登録', logout:'ログアウト',
    region:'地域', country:'国名', city:'都市',
    searchBtn:'検索', searching:'検索中…',
    localTime:'現地時間', weather:'7日間天気',
    currency:'通貨情報', voltage:'電圧・プラグ', transport:'現地交通', tips:'旅のヒント',
    emergency:'緊急連絡先', taboos:'タブー・禁止事項', tap_water:'水道水', tipping:'チップ文化',
    spots:'人気スポット', all:'すべて', culture:'文化', play:'遊び', sight:'観光',
    districtFilterHome:'エリアで絞り込み', districtFilter:'エリアで絞り込み',
    nature:'大自然', shopping:'ショッピング', food:'グルメ', topFood:'ローカルグルメTOP10',
    deals:'地元のお得情報', loading:'読み込み中…', translating:'記事を翻訳中…',
    planTrip:'旅程を計画', days:'旅行日数', style:'旅行スタイル', travelMode:'移動手段',
    genItinerary:'🗺️ ワンタップ計画', downloadPDF:'PDFをダウンロード',
    menuAbout:'EC Travelについて', menuAboutSub:'ブランドストーリーとミッション',
    menuIntel:'旅行情報', menuIntelSub:'目的地情報 · ビザ · 安全',
    menuDeals:'旅行お得情報', menuDealsSub:'早割・会員特典',
    menuEvents:'イベント情報', menuEventsSub:'今週のイベント · コンサート · 展覧会',
    menuContact:'お問い合わせ', menuContactSub:'サポート · 提携 · オフィス',
    menuFeedback:'ご意見・ご感想', menuFeedbackSub:'評価 · ご提案 · 不具合報告',
    publicTransport:'公共交通', selfDrive:'レンタカー', bicycle:'自転車',
    localTransport:'国内交通', crossBorder:'国際交通', tickets:'チケット',
    dining:'グルメ', accommodation:'宿泊',
    departure:'出発地', destination:'目的地', depDate:'出発日', returnDate:'帰国日',
    autoDaysHint:'出発日と帰国日から自動計算', autoDaysNeedDate:'出発日と帰国日を入力すると日数を自動計算します',
    searchResults:'検索結果', noResults:'結果なし。もう一度お試しください',
    estCost:'予算目安', dayLabel:'第', dayUnit:'日',
    hotel:'宿泊先', restaurant:'レストラン',
    hotelAiNote:'AIによる提案です。実際の部屋タイプや料金は下の地図でご確認ください',
    morning:'☀️ 午前', lunch:'🍱 ランチ', afternoon:'🌤 午後', evening:'🌙 夜',
    redo:'再計画', share:'共有',
    myAcc:'マイアカウント', saved:'保存', security:'セキュリティ',
    yourEarnings:'紹介報酬', thisMonth:'今月', thisWeek:'今週',
    forgotPw:'パスワードを忘れた？', sendReset:'リセットリンクを送信',
    resetSent:'メール送信完了', resetSentDesc:'受信トレイを確認してください。',
    orWith:'または', noAcc:'アカウントをお持ちでない方', hasAcc:'すでにアカウントをお持ちの方',
    emailRequired:'メール必須', emailInvalid:'メール形式が正しくない',
    pwRequired:'パスワード必須', pwPolicy:'8文字以上、大小英字と数字を含む',
    pwNoMatch:'パスワードが一致しない', phoneRequired:'電話番号必須',
    deletedCooldown:'このメールアドレスは削除されたばかりです。24時間後に再度お試しください。',
    confirmPw:'パスワード確認', birthday:'生年月日（任意）', phone:'(国番号)電話',
    selected:'選択済み', of:'，合計',
    regions:{Asia:'アジア',Europe:'ヨーロッパ',Americas:'北米','South America':'南米',Africa:'アフリカ','Middle East':'中東',Oceania:'オセアニア'},
    styleLabels:{culture:'文化体験',shopping:'ショッピング',entertainment:'エンタメ',nature:'大自然',food:'グルメ体験'},
    stylePresets:[
      {label:'🏛 文化の旅',style:{culture:50,food:20,nature:15,entertainment:10,shopping:5}},
      {label:'🛍 ショッピング',style:{shopping:50,food:20,entertainment:15,culture:10,nature:5}},
      {label:'🌿 自然探索',style:{nature:50,culture:20,food:20,entertainment:5,shopping:5}},
      {label:'👨‍👩‍👧 ファミリー',style:{entertainment:40,food:25,nature:20,culture:10,shopping:5}},
    ],
    dayOpts:Array.from({length:12},(_,i)=>`${i+1}日`),
    from:'¥', priceFrom:'〜',
    bookLinks:'予約リンク', recommended:'おすすめ',
    addDest:'目的地を追加', multiDestHint:'複数の目的地を追加可能', maxDaysHint:'会員は最大{n}日',
    activities:['テーマパーク','水族館','動物園','博物館','ペットカフェ','温泉・スパ','室内遊び場','現地文化体験','ライブバー','アウトレット'],
    daysSuffix:'日',
    freeUsed:'本日の無料利用が終了しました。次回は10秒の広告を視聴してください',
    freeLeft:'本日残り{n}回無料',
    tripSaved:'✅ 旅程を保存しました！マイページ→保存済み旅程をご確認ください',
    maxTrips:'最大{n}件まで保存可能です。古い旅程を削除してください',
    perNight:'泊', copied:'旅程をクリップボードにコピーしました！', retryTxt:'もう一度お試しください', saveTrip:'旅程を保存',
    resetStyle:'均等に分配', styleDone:'完了', styleTotalLbl:'合計',
    styleOver:'100%を超えています。減らしてください', styleNeed:'あと{n}%必要',
    termsTitle:'利用規約', privacyTitle:'プライバシーポリシー', adsTitle:'広告のお問い合わせ',
  },
  'ko':{
    aiLang:'Korean',
    app:'EC TRAVEL', tagline:'탐색 • 경험 • 수익',
    home:'현지', search:'검색', trips:'여행', booking:'예약', profile:'내 정보',
    login:'로그인', register:'회원가입', logout:'로그아웃',
    region:'지역', country:'국가', city:'도시',
    searchBtn:'검색', searching:'검색 중…',
    localTime:'현지 시간', weather:'7일 날씨',
    currency:'통화 정보', voltage:'전압·플러그', transport:'현지 교통', tips:'여행 팁',
    emergency:'긴급 전화', taboos:'금기 사항', tap_water:'수돗물', tipping:'팁 문화',
    spots:'인기 명소', all:'전체', culture:'문화', play:'놀이', sight:'명소',
    districtFilterHome:'지역별 필터', districtFilter:'지역별 필터',
    nature:'자연', shopping:'쇼핑', food:'음식', topFood:'현지 음식 TOP10',
    deals:'현지 할인', loading:'로딩 중…', translating:'기사 번역 중…',
    planTrip:'여행 계획', days:'여행 기간', style:'여행 스타일', travelMode:'이동 수단',
    genItinerary:'🗺️ 원클릭 계획', downloadPDF:'PDF 다운로드',
    menuAbout:'EC Travel 소개', menuAboutSub:'브랜드 스토리와 미션',
    menuIntel:'여행 정보', menuIntelSub:'목적지 정보 · 비자 · 안전',
    menuDeals:'여행 할인', menuDealsSub:'얼리버드 · 회원 혜택',
    menuEvents:'여행 이벤트', menuEventsSub:'이번 주 추천 · 콘서트 · 전시',
    menuContact:'문의하기', menuContactSub:'고객지원 · 파트너 · 사무실',
    menuFeedback:'의견 보내기', menuFeedbackSub:'평가 · 제안 · 문제 신고',
    publicTransport:'대중교통', selfDrive:'자가 운전', bicycle:'자전거',
    localTransport:'국내 교통', crossBorder:'국제 교통', tickets:'티켓',
    dining:'맛집', accommodation:'숙소',
    departure:'출발지', destination:'목적지', depDate:'출발일', returnDate:'귀국일',
    autoDaysHint:'출발일과 귀국일 기준으로 자동 계산', autoDaysNeedDate:'출발일과 귀국일을 입력하면 여행 일수가 자동 계산됩니다',
    searchResults:'검색 결과', noResults:'결과 없음, 다시 시도해 주세요',
    estCost:'예상 비용', dayLabel:'', dayUnit:'일차',
    hotel:'숙소 추천', restaurant:'레스토랑',
    hotelAiNote:'AI 추천입니다. 실제 객실 및 요금은 아래 지도에서 확인하세요',
    morning:'☀️ 오전', lunch:'🍱 점심', afternoon:'🌤 오후', evening:'🌙 저녁',
    redo:'다시 계획', share:'공유',
    myAcc:'내 계정', saved:'저장됨', security:'보안 설정',
    yourEarnings:'추천 수익', thisMonth:'이번 달', thisWeek:'이번 주',
    forgotPw:'비밀번호를 잊으셨나요?', sendReset:'재설정 링크 보내기',
    resetSent:'이메일 전송 완료', resetSentDesc:'받은 편지함을 확인하세요.',
    orWith:'또는', noAcc:'계정이 없으신가요?', hasAcc:'이미 계정이 있으신가요?',
    emailRequired:'이메일 필수', emailInvalid:'이메일 형식 오류',
    pwRequired:'비밀번호 필수', pwPolicy:'8자 이상, 대소문자 및 숫자 포함',
    pwNoMatch:'비밀번호 불일치', phoneRequired:'전화번호 필수',
    deletedCooldown:'이 이메일 계정은 최근 삭제되었습니다. 24시간 후 다시 시도해 주세요.',
    confirmPw:'비밀번호 확인', birthday:'생년월일 (선택)', phone:'(국가코드)전화번호',
    selected:'선택됨', of:'，총',
    regions:{Asia:'아시아',Europe:'유럽',Americas:'북미','South America':'남미',Africa:'아프리카','Middle East':'중동',Oceania:'오세아니아'},
    styleLabels:{culture:'문화 체험',shopping:'쇼핑',entertainment:'엔터테인먼트',nature:'자연',food:'미식 여행'},
    stylePresets:[
      {label:'🏛 문화 탐방',style:{culture:50,food:20,nature:15,entertainment:10,shopping:5}},
      {label:'🛍 쇼핑 투어',style:{shopping:50,food:20,entertainment:15,culture:10,nature:5}},
      {label:'🌿 자연 탐험',style:{nature:50,culture:20,food:20,entertainment:5,shopping:5}},
      {label:'👨‍👩‍👧 가족 여행',style:{entertainment:40,food:25,nature:20,culture:10,shopping:5}},
    ],
    dayOpts:Array.from({length:12},(_,i)=>`${i+1}일`),
    from:'₩', priceFrom:'~',
    bookLinks:'예약 링크', recommended:'추천',
    addDest:'목적지 추가', multiDestHint:'여러 목적지 추가 가능', maxDaysHint:'회원 최대 {n}일',
    activities:['테마파크','아쿠아리움','동물원','박물관','반려동물 카페','온천·스파','실내 놀이공간','현지 문화 체험','라이브 뮤직바','아울렛'],
    daysSuffix:'일',
    freeUsed:'오늘 무료 횟수를 모두 사용했습니다. 다음 생성을 위해 10초 광고를 시청하세요',
    freeLeft:'오늘 {n}회 무료 생성 가능',
    tripSaved:'✅ 여행 일정이 저장되었습니다! 프로필 → 저장된 일정에서 확인하세요',
    maxTrips:'최대 {n}개까지 저장 가능합니다. 기존 일정을 먼저 삭제해 주세요',
    perNight:'박', copied:'일정이 클립보드에 복사되었습니다!', retryTxt:'다시 시도해 주세요', saveTrip:'일정 저장',
    resetStyle:'균등 배분', styleDone:'완료', styleTotalLbl:'합계',
    styleOver:'100% 초과, 줄여주세요', styleNeed:'{n}% 더 필요',
    termsTitle:'이용약관', privacyTitle:'개인정보 처리방침', adsTitle:'광고 문의',
  },
};

// specify_cat taxonomy translations — keyed by the canonical zh-HK string
// stored in the DB (see enrich_attractions.js SPECIFY_CAT_OPTIONS). zh-HK
// itself needs no entry since that's the raw stored value.
export const specifyCatLabels = {
  '博物館/美術館/藝文空間': { 'zh-CN':'博物馆/美术馆/艺文空间', en:'Museums/Galleries/Art Spaces', ja:'博物館/美術館/文化施設', ko:'박물관/미술관/문화공간' },
  '宗教聖地/古蹟廟宇': { 'zh-CN':'宗教圣地/古迹庙宇', en:'Religious Sites/Historic Temples', ja:'聖地/寺院・史跡', ko:'종교 성지/유적 사원' },
  '歷史皇宮/城堡古蹟': { 'zh-CN':'历史皇宫/城堡古迹', en:'Historic Palaces/Castles', ja:'宮殿・城の史跡', ko:'역사 궁전/성곽 유적' },
  '文化地標/藝術園區': { 'zh-CN':'文化地标/艺术园区', en:'Cultural Landmarks/Art Districts', ja:'文化ランドマーク/アートエリア', ko:'문화 랜드마크/예술 지구' },
  '圖書館/文化書局': { 'zh-CN':'图书馆/文化书局', en:'Libraries/Bookstores', ja:'図書館/文化書店', ko:'도서관/문화 서점' },
  '會展中心/大型展覽活動': { 'zh-CN':'会展中心/大型展览活动', en:'Convention Centers/Major Exhibitions', ja:'コンベンションセンター/大型展示会', ko:'컨벤션센터/대형 전시' },

  '其它自然/戶外景觀': { 'zh-CN':'其它自然/户外景观', en:'Other Nature/Outdoor Scenery', ja:'その他自然/アウトドア景観', ko:'기타 자연/야외 경관' },
  '城市公園/植物綠地': { 'zh-CN':'城市公园/植物绿地', en:'City Parks/Botanical Gardens', ja:'都市公園/植物緑地', ko:'도시 공원/식물 녹지' },
  '海灘/海濱景觀': { 'zh-CN':'海滩/海滨景观', en:'Beaches/Coastal Views', ja:'ビーチ/海岸景観', ko:'해변/해안 경관' },
  '名山大川/登山步道': { 'zh-CN':'名山大川/登山步道', en:'Mountains/Hiking Trails', ja:'名山/登山道', ko:'명산/등산로' },
  '湖泊/河流/水體景觀': { 'zh-CN':'湖泊/河流/水体景观', en:'Lakes/Rivers/Waterways', ja:'湖/川/水辺景観', ko:'호수/강/수변 경관' },
  '動植物園/生態農場': { 'zh-CN':'动植物园/生态农场', en:'Zoos/Botanical Gardens/Eco Farms', ja:'動植物園/エコファーム', ko:'동식물원/생태 농장' },
  '離島風光/度假島嶼': { 'zh-CN':'离岛风光/度假岛屿', en:'Outlying Islands/Resort Islands', ja:'離島/リゾートアイランド', ko:'외딴 섬/리조트 섬' },

  '其它休閒/娛樂景點': { 'zh-CN':'其它休闲/娱乐景点', en:'Other Leisure/Entertainment', ja:'その他レジャー/エンタメ', ko:'기타 레저/엔터테인먼트' },
  '室內遊樂場/電玩/KTV': { 'zh-CN':'室内游乐场/电玩/KTV', en:'Indoor Play/Arcades/KTV', ja:'屋内遊技場/ゲーセン/カラオケ', ko:'실내 놀이시설/오락실/노래방' },
  '體育競技/運動賽事/俱樂部': { 'zh-CN':'体育竞技/运动赛事/俱乐部', en:'Sports/Events/Clubs', ja:'スポーツ/試合/クラブ', ko:'스포츠 경기/이벤트/클럽' },
  '大型主題樂園/水上樂園': { 'zh-CN':'大型主题乐园/水上乐园', en:'Theme Parks/Water Parks', ja:'テーマパーク/ウォーターパーク', ko:'테마파크/워터파크' },
  '電影院/演藝劇場': { 'zh-CN':'电影院/演艺剧场', en:'Cinemas/Theaters', ja:'映画館/劇場', ko:'영화관/공연장' },
  '渡假酒店/休閒住宿': { 'zh-CN':'度假酒店/休闲住宿', en:'Resorts/Leisure Stays', ja:'リゾートホテル/宿泊施設', ko:'리조트 호텔/휴양 숙소' },
  '遊艇碼頭/水上觀光船': { 'zh-CN':'游艇码头/水上观光船', en:'Marinas/Sightseeing Boats', ja:'マリーナ/観光船', ko:'요트 선착장/수상 관광선' },
  '溫泉/SPA/汗蒸幕': { 'zh-CN':'温泉/SPA/汗蒸幕', en:'Hot Springs/Spas/Jjimjilbang', ja:'温泉/スパ/チムジルバン', ko:'온천/스파/찜질방' },
  '按摩/足療': { 'zh-CN':'按摩/足疗', en:'Massage/Reflexology', ja:'マッサージ/足つぼ', ko:'마사지/발마사지' },

  '綜合零售/特色商店': { 'zh-CN':'综合零售/特色商店', en:'General Retail/Specialty Shops', ja:'総合小売/専門店', ko:'종합 소매/특색 상점' },
  '大型購物中心/百貨商場': { 'zh-CN':'大型购物中心/百货商场', en:'Malls/Department Stores', ja:'ショッピングモール/百貨店', ko:'대형 쇼핑몰/백화점' },
  '傳統市集/跳蚤市場/夜市': { 'zh-CN':'传统市集/跳蚤市场/夜市', en:'Markets/Flea Markets/Night Markets', ja:'伝統市場/フリーマーケット/夜市', ko:'전통 시장/벼룩시장/야시장' },
  '超級市場/大型量販店': { 'zh-CN':'超级市场/大型量贩店', en:'Supermarkets/Hypermarkets', ja:'スーパー/大型量販店', ko:'슈퍼마켓/대형 할인점' },
  '潮流服飾/精品名店': { 'zh-CN':'潮流服饰/精品名店', en:'Fashion/Boutiques', ja:'ファッション/ブティック', ko:'패션/부티크' },
  '禮品店/紀念品專賣店': { 'zh-CN':'礼品店/纪念品专卖店', en:'Gift/Souvenir Shops', ja:'ギフト/お土産店', ko:'선물/기념품 상점' },

  '特色餐廳/在地美食': { 'zh-CN':'特色餐厅/在地美食', en:'Local Specialty Restaurants', ja:'名物レストラン/ご当地グルメ', ko:'특색 레스토랑/현지 맛집' },
  '日式料理/壽司': { 'zh-CN':'日式料理/寿司', en:'Japanese/Sushi', ja:'和食/寿司', ko:'일식/스시' },
  // 2026-09-28 改名前的舊名；DB 改名完成前的過渡期仍可能讀到
  '日式料理/壽司/拉麵': { 'zh-CN':'日式料理/寿司/拉面', en:'Japanese/Sushi/Ramen', ja:'和食/寿司/ラーメン', ko:'일식/스시/라멘' },
  '日式料理/居酒屋': { 'zh-CN':'日式料理/居酒屋', en:'Japanese Izakaya', ja:'和食/居酒屋', ko:'일식/이자카야' },
  '日式料理/燒肉/鐵板燒/壽喜燒': { 'zh-CN':'日式料理/烧肉/铁板烧/寿喜烧', en:'Japanese BBQ/Teppanyaki/Sukiyaki', ja:'焼肉/鉄板焼き/すき焼き', ko:'일식 야키니쿠/철판구이/스키야키' },
  '中式料理/火鍋/粵菜': { 'zh-CN':'中式料理/火锅/粤菜', en:'Chinese Hotpot/Cantonese', ja:'中華/火鍋/広東料理', ko:'중식/훠궈/광둥요리' },
  '中式料理/火鍋/大排檔': { 'zh-CN':'中式料理/火锅/大排档', en:'Chinese Hotpot/Street Food', ja:'中華/火鍋/屋台料理', ko:'중식/훠궈/노점 음식' },
  '麵食/餃子/小籠包': { 'zh-CN':'面食/饺子/小笼包', en:'Noodles/Dumplings/Xiaolongbao', ja:'麺料理/餃子/小籠包', ko:'면 요리/만두/샤오롱바오' },
  '韓式料理': { 'zh-CN':'韩式料理', en:'Korean Cuisine', ja:'韓国料理', ko:'한식' },
  '東南亞料理/泰式/越南': { 'zh-CN':'东南亚料理/泰式/越南', en:'Southeast Asian/Thai/Vietnamese', ja:'東南アジア料理/タイ/ベトナム', ko:'동남아 요리/태국식/베트남식' },
  '印度料理/南亞料理': { 'zh-CN':'印度料理/南亚料理', en:'Indian/South Asian', ja:'インド料理/南アジア料理', ko:'인도 요리/남아시아 요리' },
  '法式料理/精緻餐廳': { 'zh-CN':'法式料理/精致餐厅', en:'French/Fine Dining', ja:'フランス料理/高級レストラン', ko:'프랑스 요리/파인다이닝' },
  '義式料理/Pizza/Pasta': { 'zh-CN':'意式料理/Pizza/Pasta', en:'Italian/Pizza/Pasta', ja:'イタリア料理/ピザ/パスタ', ko:'이탈리아 요리/피자/파스타' },
  '地中海料理/西班牙料理': { 'zh-CN':'地中海料理/西班牙料理', en:'Mediterranean/Spanish', ja:'地中海料理/スペイン料理', ko:'지중해 요리/스페인 요리' },
  '中東料理/土耳其料理': { 'zh-CN':'中东料理/土耳其料理', en:'Middle Eastern/Turkish', ja:'中東料理/トルコ料理', ko:'중동 요리/터키 요리' },
  '墨西哥料理/拉丁美洲料理': { 'zh-CN':'墨西哥料理/拉丁美洲料理', en:'Mexican/Latin American', ja:'メキシコ料理/中南米料理', ko:'멕시코 요리/라틴아메리카 요리' },
  '美式料理/漢堡/BBQ': { 'zh-CN':'美式料理/汉堡/BBQ', en:'American/Burgers/BBQ', ja:'アメリカ料理/バーガー/BBQ', ko:'미국식 요리/버거/BBQ' },
  '咖啡廳/甜點/下午茶': { 'zh-CN':'咖啡厅/甜点/下午茶', en:'Cafés/Desserts/Afternoon Tea', ja:'カフェ/デザート/アフタヌーンティー', ko:'카페/디저트/애프터눈 티' },
  '酒吧/餐酒館/夜生活': { 'zh-CN':'酒吧/餐酒馆/夜生活', en:'Bars/Gastropubs/Nightlife', ja:'バー/ガストロパブ/ナイトライフ', ko:'바/가스트로펍/나이트라이프' },
  '素食/蔬食/健康餐': { 'zh-CN':'素食/蔬食/健康餐', en:'Vegetarian/Vegan/Healthy', ja:'ベジタリアン/ヴィーガン/健康食', ko:'채식/비건/건강식' },
  'Halal/清真餐廳': { 'zh-CN':'Halal/清真餐厅', en:'Halal Restaurants', ja:'ハラールレストラン', ko:'할랄 레스토랑' },
};

export default T;
